import styled from '@emotion/styled';

import { IconButton, tokens, Icon } from '@hotjar/hotsauce';

export const HighlightActionsTrigger = styled(IconButton)<{ isVisible: boolean }>`
  position: absolute;
  top: ${tokens.spacer.x1};
  right: ${tokens.spacer.x1};
  z-index: 1;
  background-color: ${tokens.color.bg_hover};
  border-radius: ${tokens.radius.m};
  &:focus {
    background-color: ${tokens.color.white};
  }

  ${({ isVisible }) => (!isVisible ? 'visibility: hidden;' : '')}

  button {
    color: ${tokens.ALIAS_COLORS.primary_cta};

    &:focus {
      background-color: ${tokens.color.white};
    }
  }
`;

export const ColoredText = styled.span<{ color?: React.ComponentProps<typeof Icon>['color'] }>`
  ${({ color }) =>
    color && color !== 'inherited' && tokens.ALIAS_TEXT_COLORS[color]
      ? `color: ${tokens.ALIAS_TEXT_COLORS[color]};`
      : ''}
`;

export const ActionIcon = styled(Icon)`
  margin-right: ${tokens.spacer.x1};
`;
